module.exports = __webpack_public_path__ + "media/src/images/page01_zu_worksheet0201-10300584ab3c094c68f56717fe618b43.png";